import { Grid, Box, MenuItem, Button } from '@mui/material';
import { TextField } from '@mui/material';
import MainCard from './MainCard';
import { gridSpacing } from '../../store/constant';
import axios from "../../components/axios";
import { useNavigate } from 'react-router-dom';
import { Controller, useForm } from "react-hook-form";


const UserForm = () => {
  const navigate = useNavigate();
  const permission = [
    {
      value: '0',
      label: 'Disabable',
    },
    {
      value: '1',
      label: 'Enable',
    },
  ];

  const roles = [
    {
      value: '1',
      label: 'Admin',
    },
    {
      value: '2',
      label: 'Engineer',
    },
  ];

  const styleButton = {
    marginTop: "40px",
    backgroundColor: "#406599",
    color: "#fff",
    borderRadius: "5px",
    boxSizing: "border-box",
    width: "100px",
    height: "45px",
    fontFamily: '"Roboto", "sans-serif"',
    fontSize: "15px",
  };

  const { handleSubmit,control } = useForm();
  const onSubmit = (data) => {
      var input_data = JSON.stringify({ email: data.userEmail, role: data.userRole, project_permission: [
        {project_name:'Tread',state:data.userTread},{project_name:'Bike',state:data.userBike},
        {project_name:'BikePlus',state:data.userBikeplus},{project_name:'Caesar',state:data.userCaesar},
        {project_name:'Upload',state:data.userUpload},{project_name:'Self_Diagnostic',state:data.userDiagnostic},
        {project_name:'Upload',state:data.userUpload},{project_name:'Passerine',state:data.userPasserine},
        {project_name:'Automation',state:data.userAutomation}] });

        axios.post("/peloton/v1/users/create-user",input_data,{withCredentials: true})
        .then(response => {
            if (response.data.message === "success") {
              navigate("/user-list");
            }else{
                alert(response.data.message);
            }
        }).catch(function(err){
          if (!err.response){
            alert(err);
          }else{
            if (err.response.status === 401){
              alert(err.response.data.message);
              navigate("/");
            }else{
                console.log('error.response.status: ', err.response.status);
                console.log('error.response.status: ', err.response.data.message);
                alert(err.response.data.message);
            }
          }
        })
  };

  const onError = (errors, e) => {
    if (errors.userEmail !== null){
      if (errors.userEmail.type === 'pattern'){
        alert("Email format error !");
      }

      if (errors.userEmail.type === 'required'){
        alert("Email is necessary !");
      }
    }
  };

    return (
      <MainCard title="Add QBarn User">
        <Box sx={{ maxWidth: '100%'}}>
          <form onSubmit={handleSubmit(onSubmit, onError)}>
            <Grid container spacing={gridSpacing} justifyContent="center" rowSpacing={gridSpacing} columnSpacing={gridSpacing}>
              <Grid item xs={4}>
                <Controller
                  name="userEmail"
                  control={control}
                  rules={{
                    required: true,
                    pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(onepeloton.com)$/
                  }}
                  defaultValue=''
                  render={({ field: { ref, ...field } }) => (
                    <TextField
                      {...field}
                      inputRef={ref}
                      fullWidth
                      id="user-email"
                      label="User Email"
                      variant="filled"
                    />)}/>
              </Grid>
              <Grid item xs={4}>
                <Controller
                  name="userRole"
                  control={control}
                  rules={{ required: true }}
                  defaultValue="2"
                  render={({ field: { ref, ...field } }) => (
                    <TextField
                    {...field}
                    inputRef={ref}
                    id="user-role"
                    select
                    fullWidth
                    label="Select Role"
                    helperText="Please select user role"
                    variant="filled">
                  {roles.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>)}/>
              </Grid>
              <Grid item xs={4}>
                <Controller
                  name="userTread"
                  control={control}
                  rules={{ required: true }}
                  defaultValue='0'
                  render={({ field: { ref, ...field } }) => (
                    <TextField
                    {...field}
                    inputRef={ref}
                    id="user-tread"
                    select
                    fullWidth
                    label="Select Tread Permission">
                    {permission.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>)}/>
              </Grid>
              <Grid item xs={4}>
                <Controller
                  name="userBike"
                  control={control}
                  rules={{ required: true }}
                  defaultValue='0'
                  render={({ field: { ref, ...field } }) => (
                    <TextField
                      {...field}
                      inputRef={ref}
                      id="user-bike"
                      select
                      fullWidth
                      label="Select Bike Permission">
                      {permission.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>)}/>
              </Grid>
              <Grid item xs={4}>
                <Controller
                  name="userBikeplus"
                  control={control}
                  rules={{ required: true }}
                  defaultValue='0'
                  render={({ field: { ref, ...field } }) => (
                    <TextField
                    {...field}
                    inputRef={ref}
                    id="user-bikeplus"
                    select
                    fullWidth
                    label="Select Bikeplus Permission">
                    {permission.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>)}/>
              </Grid>
              <Grid item xs={4}>
                <Controller
                    name="userCaesar"
                    control={control}
                    rules={{ required: true }}
                    defaultValue='0'
                    render={({ field: { ref, ...field } }) => (
                      <TextField
                      {...field}
                      inputRef={ref}
                      id="user-caesar"
                      select
                      fullWidth
                      label="Select Caesar Permission">
                      {permission.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>)}/>
              </Grid>
              <Grid item xs={4}>
                <Controller
                    name="userUpload"
                    control={control}
                    rules={{ required: true }}
                    defaultValue='0'
                    render={({ field: { ref, ...field } }) => (
                      <TextField
                      {...field}
                      inputRef={ref}
                      id="user-upload"
                      select
                      fullWidth
                      label="Select Upload Permission">
                      {permission.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>)}/>
              </Grid>
              <Grid item xs={4}>
                <Controller
                    name="userDiagnostic"
                    control={control}
                    rules={{ required: true }}
                    defaultValue='0'
                    render={({ field: { ref, ...field } }) => (
                    <TextField
                    {...field}
                    inputRef={ref}
                    id="user-diagnostic"
                    select
                    fullWidth
                    label="Select self diagnostic Permission">
                    {permission.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>)}/>
              </Grid>
              <Grid item xs={4} justifyContent="flex-start">
                <Controller
                    name="userPasserine"
                    control={control}
                    rules={{ required: true }}
                    defaultValue='0'
                    render={({ field: { ref, ...field } }) => (
                    <TextField
                    {...field}
                    inputRef={ref}
                    id="user-passerine"
                    select
                    fullWidth
                    label="Select Passerine Permission">
                    {permission.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>)}/>
              </Grid>
            </Grid>
            <Grid container spacing={gridSpacing} justifyContent="flex-start">
              <Grid item xs={4} sx={{ marginTop: '30px' }} justifyContent="flex-start">
                  <Controller
                      name="userAutomation"
                      control={control}
                      rules={{ required: true }}
                      defaultValue='0'
                      render={({ field: { ref, ...field } }) => (
                      <TextField
                      {...field}
                      inputRef={ref}
                      id="user-automation"
                      select
                      fullWidth
                      label="Select Automation Permission">
                      {permission.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>)}/>
                </Grid>
              <Grid container spacing={gridSpacing} justifyContent="flex-end">
              <Grid item>
              <Button type="submit" style={styleButton}>Send</Button>
              </Grid>
              </Grid>
            </Grid>
          </form>
        </Box>
      </MainCard>
    );
};

export default UserForm;
